import axios from "axios";
import Globais, { validateToken } from "../../components/Globais";


//função que verifica o status de determinada cotaUsuario. retorna o status
export async function atualizarApartamento(aptoId: number, formData: any) {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/apto/${aptoId}`;

    try {
      const response = await axios.put(URL, formData,{
        headers: { Authorization: Token.AuthStr },
      });
      if (response) {
        return true;;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  } else {
    document.location.href = "/login";
    return false;
  }
}